// removed by extract-text-webpack-plugin
module.exports = {"header":"header___Aosqr","titleSection":"titleSection___1XYvl","title":"title___q1RGN","description":"description___1I0d0","userSection":"userSection___2fRXW","userDataBlock":"userDataBlock___1o7N7","avatarWrap":"avatarWrap___27Qcc","accSwitcher":"accSwitcher___16vg9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TopHeader/styles.less
// module id = fgdG
// module chunks = 18